var _g, _g2, _g3, _g4, _g5, _g6, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _g7, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 697,
    height: 269,
    viewBox: "0 0 697 269",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_664_33486)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_664_33486)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M159.227 83.0421C159.227 83.4504 158.896 83.7814 158.488 83.7814C158.08 83.7814 157.749 83.4504 157.749 83.0421C157.749 82.6338 158.08 82.3027 158.488 82.3027C158.896 82.3027 159.227 82.6338 159.227 83.0421Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.45 83.0421C178.45 83.4504 178.119 83.7814 177.711 83.7814C177.303 83.7814 176.972 83.4504 176.972 83.0421C176.972 82.6338 177.303 82.3027 177.711 82.3027C178.119 82.3027 178.45 82.6338 178.45 83.0421Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.673 83.0421C197.673 83.4504 197.342 83.7814 196.934 83.7814C196.525 83.7814 196.194 83.4504 196.194 83.0421C196.194 82.6338 196.525 82.3027 196.934 82.3027C197.342 82.3027 197.673 82.6338 197.673 83.0421Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.896 83.0421C216.896 83.4504 216.565 83.7814 216.157 83.7814C215.749 83.7814 215.417 83.4504 215.417 83.0421C215.417 82.6338 215.749 82.3027 216.157 82.3027C216.565 82.3027 216.896 82.6338 216.896 83.0421Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.119 83.0421C236.119 83.4504 235.788 83.7814 235.38 83.7814C234.972 83.7814 234.641 83.4504 234.641 83.0421C234.641 82.6338 234.972 82.3027 235.38 82.3027C235.788 82.3027 236.119 82.6338 236.119 83.0421Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.342 83.0421C255.342 83.4504 255.011 83.7814 254.603 83.7814C254.195 83.7814 253.864 83.4504 253.864 83.0421C253.864 82.6338 254.195 82.3027 254.603 82.3027C255.011 82.3027 255.342 82.6338 255.342 83.0421Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.565 83.0421C274.565 83.4504 274.234 83.7814 273.826 83.7814C273.418 83.7814 273.086 83.4504 273.086 83.0421C273.086 82.6338 273.418 82.3027 273.826 82.3027C274.234 82.3027 274.565 82.6338 274.565 83.0421Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.788 83.0421C293.788 83.4504 293.457 83.7814 293.049 83.7814C292.641 83.7814 292.31 83.4504 292.31 83.0421C292.31 82.6338 292.641 82.3027 293.049 82.3027C293.457 82.3027 293.788 82.6338 293.788 83.0421Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.011 83.0421C313.011 83.4504 312.68 83.7814 312.272 83.7814C311.864 83.7814 311.533 83.4504 311.533 83.0421C311.533 82.6338 311.864 82.3027 312.272 82.3027C312.68 82.3027 313.011 82.6338 313.011 83.0421Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.235 83.0421C332.235 83.4504 331.903 83.7814 331.495 83.7814C331.087 83.7814 330.756 83.4504 330.756 83.0421C330.756 82.6338 331.087 82.3027 331.495 82.3027C331.903 82.3027 332.235 82.6338 332.235 83.0421Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.227 102.265C159.227 102.673 158.896 103.004 158.488 103.004C158.08 103.004 157.749 102.673 157.749 102.265C157.749 101.857 158.08 101.526 158.488 101.526C158.896 101.526 159.227 101.857 159.227 102.265Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.45 102.265C178.45 102.673 178.119 103.004 177.711 103.004C177.303 103.004 176.972 102.673 176.972 102.265C176.972 101.857 177.303 101.526 177.711 101.526C178.119 101.526 178.45 101.857 178.45 102.265Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.673 102.265C197.673 102.673 197.342 103.004 196.934 103.004C196.525 103.004 196.194 102.673 196.194 102.265C196.194 101.857 196.525 101.526 196.934 101.526C197.342 101.526 197.673 101.857 197.673 102.265Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.896 102.265C216.896 102.673 216.565 103.004 216.157 103.004C215.749 103.004 215.417 102.673 215.417 102.265C215.417 101.857 215.749 101.526 216.157 101.526C216.565 101.526 216.896 101.857 216.896 102.265Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.119 102.265C236.119 102.673 235.788 103.004 235.38 103.004C234.972 103.004 234.641 102.673 234.641 102.265C234.641 101.857 234.972 101.526 235.38 101.526C235.788 101.526 236.119 101.857 236.119 102.265Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.342 102.265C255.342 102.673 255.011 103.004 254.603 103.004C254.195 103.004 253.864 102.673 253.864 102.265C253.864 101.857 254.195 101.526 254.603 101.526C255.011 101.526 255.342 101.857 255.342 102.265Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.565 102.265C274.565 102.673 274.234 103.004 273.826 103.004C273.418 103.004 273.086 102.673 273.086 102.265C273.086 101.857 273.418 101.526 273.826 101.526C274.234 101.526 274.565 101.857 274.565 102.265Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.788 102.265C293.788 102.673 293.457 103.004 293.049 103.004C292.641 103.004 292.31 102.673 292.31 102.265C292.31 101.857 292.641 101.526 293.049 101.526C293.457 101.526 293.788 101.857 293.788 102.265Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.011 102.265C313.011 102.673 312.68 103.004 312.272 103.004C311.864 103.004 311.533 102.673 311.533 102.265C311.533 101.857 311.864 101.526 312.272 101.526C312.68 101.526 313.011 101.857 313.011 102.265Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.235 102.265C332.235 102.673 331.903 103.004 331.495 103.004C331.087 103.004 330.756 102.673 330.756 102.265C330.756 101.857 331.087 101.526 331.495 101.526C331.903 101.526 332.235 101.857 332.235 102.265Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.227 121.488C159.227 121.896 158.896 122.227 158.488 122.227C158.08 122.227 157.749 121.896 157.749 121.488C157.749 121.08 158.08 120.749 158.488 120.749C158.896 120.749 159.227 121.08 159.227 121.488Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.45 121.488C178.45 121.896 178.119 122.227 177.711 122.227C177.303 122.227 176.972 121.896 176.972 121.488C176.972 121.08 177.303 120.749 177.711 120.749C178.119 120.749 178.45 121.08 178.45 121.488Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.673 121.488C197.673 121.896 197.342 122.227 196.934 122.227C196.525 122.227 196.194 121.896 196.194 121.488C196.194 121.08 196.525 120.749 196.934 120.749C197.342 120.749 197.673 121.08 197.673 121.488Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.896 121.488C216.896 121.896 216.565 122.227 216.157 122.227C215.749 122.227 215.417 121.896 215.417 121.488C215.417 121.08 215.749 120.749 216.157 120.749C216.565 120.749 216.896 121.08 216.896 121.488Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.119 121.488C236.119 121.896 235.788 122.227 235.38 122.227C234.972 122.227 234.641 121.896 234.641 121.488C234.641 121.08 234.972 120.749 235.38 120.749C235.788 120.749 236.119 121.08 236.119 121.488Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.342 121.488C255.342 121.896 255.011 122.227 254.603 122.227C254.195 122.227 253.864 121.896 253.864 121.488C253.864 121.08 254.195 120.749 254.603 120.749C255.011 120.749 255.342 121.08 255.342 121.488Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.565 121.488C274.565 121.896 274.234 122.227 273.826 122.227C273.418 122.227 273.086 121.896 273.086 121.488C273.086 121.08 273.418 120.749 273.826 120.749C274.234 120.749 274.565 121.08 274.565 121.488Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.788 121.488C293.788 121.896 293.457 122.227 293.049 122.227C292.641 122.227 292.31 121.896 292.31 121.488C292.31 121.08 292.641 120.749 293.049 120.749C293.457 120.749 293.788 121.08 293.788 121.488Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.011 121.488C313.011 121.896 312.68 122.227 312.272 122.227C311.864 122.227 311.533 121.896 311.533 121.488C311.533 121.08 311.864 120.749 312.272 120.749C312.68 120.749 313.011 121.08 313.011 121.488Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.235 121.488C332.235 121.896 331.903 122.227 331.495 122.227C331.087 122.227 330.756 121.896 330.756 121.488C330.756 121.08 331.087 120.749 331.495 120.749C331.903 120.749 332.235 121.08 332.235 121.488Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.986 83.0421C522.986 83.4504 523.317 83.7814 523.725 83.7814C524.133 83.7814 524.465 83.4504 524.465 83.0421C524.465 82.6338 524.133 82.3027 523.725 82.3027C523.317 82.3027 522.986 82.6338 522.986 83.0421Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.763 83.0421C503.763 83.4504 504.094 83.7814 504.502 83.7814C504.91 83.7814 505.241 83.4504 505.241 83.0421C505.241 82.6338 504.91 82.3027 504.502 82.3027C504.094 82.3027 503.763 82.6338 503.763 83.0421Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.54 83.0421C484.54 83.4504 484.871 83.7814 485.279 83.7814C485.687 83.7814 486.018 83.4504 486.018 83.0421C486.018 82.6338 485.687 82.3027 485.279 82.3027C484.871 82.3027 484.54 82.6338 484.54 83.0421Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.317 83.0421C465.317 83.4504 465.648 83.7814 466.056 83.7814C466.464 83.7814 466.796 83.4504 466.796 83.0421C466.796 82.6338 466.464 82.3027 466.056 82.3027C465.648 82.3027 465.317 82.6338 465.317 83.0421Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.094 83.0421C446.094 83.4504 446.425 83.7814 446.833 83.7814C447.241 83.7814 447.572 83.4504 447.572 83.0421C447.572 82.6338 447.241 82.3027 446.833 82.3027C446.425 82.3027 446.094 82.6338 446.094 83.0421Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.871 83.0421C426.871 83.4504 427.202 83.7814 427.61 83.7814C428.018 83.7814 428.349 83.4504 428.349 83.0421C428.349 82.6338 428.018 82.3027 427.61 82.3027C427.202 82.3027 426.871 82.6338 426.871 83.0421Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.647 83.0421C407.647 83.4504 407.979 83.7814 408.387 83.7814C408.795 83.7814 409.126 83.4504 409.126 83.0421C409.126 82.6338 408.795 82.3027 408.387 82.3027C407.979 82.3027 407.647 82.6338 407.647 83.0421Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.425 83.0421C388.425 83.4504 388.756 83.7814 389.164 83.7814C389.572 83.7814 389.903 83.4504 389.903 83.0421C389.903 82.6338 389.572 82.3027 389.164 82.3027C388.756 82.3027 388.425 82.6338 388.425 83.0421Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.202 83.0421C369.202 83.4504 369.533 83.7814 369.941 83.7814C370.349 83.7814 370.68 83.4504 370.68 83.0421C370.68 82.6338 370.349 82.3027 369.941 82.3027C369.533 82.3027 369.202 82.6338 369.202 83.0421Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.979 83.0421C349.979 83.4504 350.31 83.7814 350.718 83.7814C351.126 83.7814 351.457 83.4504 351.457 83.0421C351.457 82.6338 351.126 82.3027 350.718 82.3027C350.31 82.3027 349.979 82.6338 349.979 83.0421Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.986 102.265C522.986 102.673 523.317 103.004 523.725 103.004C524.133 103.004 524.465 102.673 524.465 102.265C524.465 101.857 524.133 101.526 523.725 101.526C523.317 101.526 522.986 101.857 522.986 102.265Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.763 102.265C503.763 102.673 504.094 103.004 504.502 103.004C504.91 103.004 505.241 102.673 505.241 102.265C505.241 101.857 504.91 101.526 504.502 101.526C504.094 101.526 503.763 101.857 503.763 102.265Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.54 102.265C484.54 102.673 484.871 103.004 485.279 103.004C485.687 103.004 486.018 102.673 486.018 102.265C486.018 101.857 485.687 101.526 485.279 101.526C484.871 101.526 484.54 101.857 484.54 102.265Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.317 102.265C465.317 102.673 465.648 103.004 466.056 103.004C466.464 103.004 466.796 102.673 466.796 102.265C466.796 101.857 466.464 101.526 466.056 101.526C465.648 101.526 465.317 101.857 465.317 102.265Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.094 102.265C446.094 102.673 446.425 103.004 446.833 103.004C447.241 103.004 447.572 102.673 447.572 102.265C447.572 101.857 447.241 101.526 446.833 101.526C446.425 101.526 446.094 101.857 446.094 102.265Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.871 102.265C426.871 102.673 427.202 103.004 427.61 103.004C428.018 103.004 428.349 102.673 428.349 102.265C428.349 101.857 428.018 101.526 427.61 101.526C427.202 101.526 426.871 101.857 426.871 102.265Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.647 102.265C407.647 102.673 407.979 103.004 408.387 103.004C408.795 103.004 409.126 102.673 409.126 102.265C409.126 101.857 408.795 101.526 408.387 101.526C407.979 101.526 407.647 101.857 407.647 102.265Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.425 102.265C388.425 102.673 388.756 103.004 389.164 103.004C389.572 103.004 389.903 102.673 389.903 102.265C389.903 101.857 389.572 101.526 389.164 101.526C388.756 101.526 388.425 101.857 388.425 102.265Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.202 102.265C369.202 102.673 369.533 103.004 369.941 103.004C370.349 103.004 370.68 102.673 370.68 102.265C370.68 101.857 370.349 101.526 369.941 101.526C369.533 101.526 369.202 101.857 369.202 102.265Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.979 102.265C349.979 102.673 350.31 103.004 350.718 103.004C351.126 103.004 351.457 102.673 351.457 102.265C351.457 101.857 351.126 101.526 350.718 101.526C350.31 101.526 349.979 101.857 349.979 102.265Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.986 121.488C522.986 121.896 523.317 122.227 523.725 122.227C524.133 122.227 524.465 121.896 524.465 121.488C524.465 121.08 524.133 120.749 523.725 120.749C523.317 120.749 522.986 121.08 522.986 121.488Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.763 121.488C503.763 121.896 504.094 122.227 504.502 122.227C504.91 122.227 505.241 121.896 505.241 121.488C505.241 121.08 504.91 120.749 504.502 120.749C504.094 120.749 503.763 121.08 503.763 121.488Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.54 121.488C484.54 121.896 484.871 122.227 485.279 122.227C485.687 122.227 486.018 121.896 486.018 121.488C486.018 121.08 485.687 120.749 485.279 120.749C484.871 120.749 484.54 121.08 484.54 121.488Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.317 121.488C465.317 121.896 465.648 122.227 466.056 122.227C466.464 122.227 466.796 121.896 466.796 121.488C466.796 121.08 466.464 120.749 466.056 120.749C465.648 120.749 465.317 121.08 465.317 121.488Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.094 121.488C446.094 121.896 446.425 122.227 446.833 122.227C447.241 122.227 447.572 121.896 447.572 121.488C447.572 121.08 447.241 120.749 446.833 120.749C446.425 120.749 446.094 121.08 446.094 121.488Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.871 121.488C426.871 121.896 427.202 122.227 427.61 122.227C428.018 122.227 428.349 121.896 428.349 121.488C428.349 121.08 428.018 120.749 427.61 120.749C427.202 120.749 426.871 121.08 426.871 121.488Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.647 121.488C407.647 121.896 407.979 122.227 408.387 122.227C408.795 122.227 409.126 121.896 409.126 121.488C409.126 121.08 408.795 120.749 408.387 120.749C407.979 120.749 407.647 121.08 407.647 121.488Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.425 121.488C388.425 121.896 388.756 122.227 389.164 122.227C389.572 122.227 389.903 121.896 389.903 121.488C389.903 121.08 389.572 120.749 389.164 120.749C388.756 120.749 388.425 121.08 388.425 121.488Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.202 121.488C369.202 121.896 369.533 122.227 369.941 122.227C370.349 122.227 370.68 121.896 370.68 121.488C370.68 121.08 370.349 120.749 369.941 120.749C369.533 120.749 369.202 121.08 369.202 121.488Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.979 121.488C349.979 121.896 350.31 122.227 350.718 122.227C351.126 122.227 351.457 121.896 351.457 121.488C351.457 121.08 351.126 120.749 350.718 120.749C350.31 120.749 349.979 121.08 349.979 121.488Z",
    fill: "#22328A",
    fillOpacity: 0.2
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_664_33486)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 32.0596,
    y: 87.0896,
    width: 140.476,
    height: 140.476,
    rx: 11.8295,
    fill: "url(#paint0_linear_664_33486)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.7989,
    y: 87.8289,
    width: 138.997,
    height: 138.997,
    rx: 11.0902,
    stroke: "#E0E7FD",
    strokeWidth: 1.47869
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_664_33486)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 196.194,
    y: 87.0896,
    width: 140.476,
    height: 140.476,
    rx: 11.8295,
    fill: "url(#paint1_linear_664_33486)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196.934,
    y: 87.8289,
    width: 138.997,
    height: 138.997,
    rx: 11.0902,
    stroke: "#E0E7FD",
    strokeWidth: 1.47869
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_b_664_33486)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 360.33,
    y: 87.0896,
    width: 140.476,
    height: 140.476,
    rx: 11.8295,
    fill: "url(#paint2_linear_664_33486)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.069,
    y: 87.8289,
    width: 138.997,
    height: 138.997,
    rx: 11.0902,
    stroke: "#E0E7FD",
    strokeWidth: 1.47869
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_b_664_33486)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 524.464,
    y: 87.0896,
    width: 140.476,
    height: 140.476,
    rx: 11.8295,
    fill: "url(#paint3_linear_664_33486)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 525.204,
    y: 87.8289,
    width: 138.997,
    height: 138.997,
    rx: 11.0902,
    stroke: "#E0E7FD",
    strokeWidth: 1.47869
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_664_33486)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_664_33486)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_664_33486)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M471.971 224.608V85.6109C471.971 78.6694 466.343 73.042 459.402 73.042H307.161C302.459 73.042 297.87 71.5956 294.017 68.8989L276.663 56.7508C272.562 53.8801 267.677 52.3403 262.671 52.3403H222.811C215.869 52.3403 210.242 57.9676 210.242 64.9092V224.608C210.242 231.549 215.869 237.177 222.811 237.177H459.402C466.343 237.177 471.971 231.549 471.971 224.608Z",
    stroke: "#0E0948",
    strokeOpacity: 0.04,
    strokeWidth: 1.47869
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_di_664_33486)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M210.981 64.9091C210.981 58.3759 216.278 53.0796 222.811 53.0796H262.671C267.525 53.0796 272.262 54.5727 276.239 57.3564L293.593 69.5045C297.57 72.2881 302.307 73.7813 307.161 73.7813H459.402C465.935 73.7813 471.231 79.0775 471.231 85.6108V224.608C471.231 231.141 465.935 236.438 459.402 236.438H222.811C216.278 236.438 210.981 231.141 210.981 224.608V64.9091Z",
    fill: "url(#paint4_linear_664_33486)"
  })))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 225.768,
    y: 87.0896,
    width: 2.95739,
    height: 100.551,
    rx: 1.47869,
    fill: "#D9D9D9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 226.507,
    y: 87.8289,
    width: 1.47869,
    height: 99.0725,
    rx: 0.739347,
    stroke: "#0E0948",
    strokeOpacity: 0.04,
    strokeWidth: 1.47869
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 237.598,
    y: 87.0896,
    width: 117.926,
    height: 100.551,
    rx: 5.91477,
    fill: "url(#paint5_linear_664_33486)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 237.598,
    y: 87.0896,
    width: 117.926,
    height: 100.551,
    rx: 5.91477,
    fill: "url(#paint6_radial_664_33486)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 238.337,
    y: 87.8289,
    width: 116.447,
    height: 99.0725,
    rx: 5.17543,
    stroke: "#0E0948",
    strokeOpacity: 0.04,
    strokeWidth: 1.47869
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 364.396,
    y: 87.0896,
    width: 92.0487,
    height: 100.551,
    rx: 5.91477,
    fill: "url(#paint7_linear_664_33486)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 364.396,
    y: 87.0896,
    width: 92.0487,
    height: 100.551,
    rx: 5.91477,
    fill: "url(#paint8_radial_664_33486)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 365.135,
    y: 87.8289,
    width: 90.57,
    height: 99.0725,
    rx: 5.17543,
    stroke: "#0E0948",
    strokeOpacity: 0.04,
    strokeWidth: 1.47869
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_biii_664_33486)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 208.024,
    y: 109.27,
    width: 266.165,
    height: 131.604,
    rx: 11.8295,
    fill: "url(#paint9_linear_664_33486)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.024,
    y: 109.27,
    width: 266.165,
    height: 131.604,
    rx: 11.8295,
    fill: "url(#paint10_radial_664_33486)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.763,
    y: 110.009,
    width: 264.686,
    height: 130.125,
    rx: 11.0902,
    stroke: "#E8E7EB",
    strokeWidth: 1.47869
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-79-inside-1_664_33486",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M341.106 110.749H472.71V239.395H341.106V110.749Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M342.585 239.395V110.749H339.628V239.395H342.585Z",
    fill: "#0E0948",
    fillOpacity: 0.06,
    mask: "url(#path-79-inside-1_664_33486)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 342.585,
    y: 180.247,
    width: 130.125,
    height: 1.47869,
    fill: "#0E0948",
    fillOpacity: 0.04
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_664_33486",
    x: 29.1022,
    y: 84.1322,
    width: 146.391,
    height: 146.391,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 1.47869
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_664_33486"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_664_33486",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_664_33486",
    x: 193.237,
    y: 84.1322,
    width: 146.391,
    height: 146.391,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 1.47869
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_664_33486"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_664_33486",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_b_664_33486",
    x: 357.372,
    y: 84.1322,
    width: 146.391,
    height: 146.391,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 1.47869
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_664_33486"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_664_33486",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_b_664_33486",
    x: 521.507,
    y: 84.1322,
    width: 146.391,
    height: 146.391,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 1.47869
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_664_33486"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_664_33486",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_di_664_33486",
    x: 208.024,
    y: 51.6009,
    width: 266.165,
    height: 189.273,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.47869
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.47869
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.056512 0 0 0 0 0.0368 0 0 0 0 0.2832 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_664_33486"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_664_33486",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.95739
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.056512 0 0 0 0 0.0368 0 0 0 0 0.2832 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_664_33486"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_biii_664_33486",
    x: 193.237,
    y: 94.4831,
    width: 295.738,
    height: 175.965,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 7.39347
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_664_33486"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_664_33486",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.47869,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_innerShadow_664_33486"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 29.5739
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20.7017
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_664_33486"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.47869,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect3_innerShadow_664_33486"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -4.43608
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.21804
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0745098 0 0 0 0 0.152941 0 0 0 0 0.423529 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_664_33486",
    result: "effect3_innerShadow_664_33486"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.47869,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect4_innerShadow_664_33486"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -8.87216
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.369673
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0745098 0 0 0 0 0.152941 0 0 0 0 0.427451 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_innerShadow_664_33486",
    result: "effect4_innerShadow_664_33486"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_664_33486",
    x1: 102.298,
    y1: 87.0896,
    x2: 102.298,
    y2: 227.565,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CACEFF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1BCFE",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_664_33486",
    x1: 266.432,
    y1: 87.0896,
    x2: 266.432,
    y2: 227.565,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CACEFF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1BCFE",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_664_33486",
    x1: 430.568,
    y1: 87.0896,
    x2: 430.568,
    y2: 227.565,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CACEFF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1BCFE",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_664_33486",
    x1: 594.702,
    y1: 87.0896,
    x2: 594.702,
    y2: 227.565,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CACEFF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1BCFE",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_664_33486",
    x1: 341.106,
    y1: 53.0796,
    x2: 341.106,
    y2: 236.438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_664_33486",
    x1: 296.561,
    y1: 87.0896,
    x2: 296.561,
    y2: 187.641,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEC9F8",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4E7FD",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_664_33486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(296.561 87.0896) scale(65.0361 55.454)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_664_33486",
    x1: 410.42,
    y1: 87.0896,
    x2: 410.42,
    y2: 187.641,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D5D8E7",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEFF3",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_664_33486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(410.42 87.0896) scale(50.7648 55.454)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_664_33486",
    x1: 341.106,
    y1: 109.27,
    x2: 341.106,
    y2: 240.874,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.49
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_664_33486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(341.106 109.27) scale(173.673 106.928)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_664_33486"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 399.247,
    height: 138.997,
    fill: "white",
    transform: "translate(141.483 0.974609)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_664_33486"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 366.716,
    height: 251.378,
    fill: "white",
    transform: "translate(157.749 82.3027)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_664_33486"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 266.165,
    height: 189.273,
    fill: "white",
    transform: "translate(208.024 51.6011)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_664_33486"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 266.165,
    height: 189.273,
    fill: "white",
    transform: "translate(208.024 51.6011)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_664_33486"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 266.165,
    height: 189.273,
    fill: "white",
    transform: "translate(208.024 51.6011)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg4);
export default __webpack_public_path__ + "static/media/4.e9015f141b623e4d3bc64ec83c2f0dda.svg";
export { ForwardRef as ReactComponent };